import { usePathname, useRouter, useSearchParams } from "next/navigation";

import { useSelector } from "@/redux/hooks";
import { getIsDelta9Allowed } from "@/redux/selectors/complianceRules";
import toggleURLSearchParamValue from "@/utils/toggleURLSearchParamValue";

import FilterShortcut from "@/components/botanic/FilterShortcut";
import { FULFILLMENT_METHODS } from "@/components/MobileFilterModalUI/MobileFilterModalUI";

const MobileMenuFulfillmentShortcuts = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { push } = useRouter();

  const targetURLSearchParams = new URLSearchParams(searchParams?.toString());
  // * Remove pagination params when clicking fulfillment filter link.
  targetURLSearchParams.delete("page");

  // * In states where Delta9 products are legal, we want to hide our direct shipping quick filter. (original ticket: https://leafly.atlassian.net/browse/SHH-1044)
  const hideShippingQuickFilter = useSelector(getIsDelta9Allowed);

  let queryStringFulfillments: string[] = [];
  if (searchParams) {
    if (searchParams.getAll("fulfillment").length > 0) {
      queryStringFulfillments = searchParams.getAll("fulfillment");
    } else if (searchParams.getAll("fulfillment[]").length > 0) {
      queryStringFulfillments = searchParams.getAll("fulfillment[]");
    }
  }

  const nonAppliedFulfillmentMethods = FULFILLMENT_METHODS.filter(
    (method) => !queryStringFulfillments.includes(method.value),
  );

  return nonAppliedFulfillmentMethods.map((fulfillment) =>
    hideShippingQuickFilter && fulfillment.value === "shipping" ? null : (
      <FilterShortcut
        key={fulfillment.value}
        text={fulfillment.name}
        showChevron={false}
        onClick={() => {
          const queryString = toggleURLSearchParamValue(
            targetURLSearchParams,
            "fulfillment",
            fulfillment.value,
            { forceArray: true },
          ).toString();
          push(`${pathname}${queryString ? `?${queryString}` : ""}`);
        }}
      />
    ),
  );
};

export default MobileMenuFulfillmentShortcuts;
